<template>
  <section class="favorites-page">
    <button type="button" class="back" @click="$emit('setIsChangePage', 'home')">‹ До каталогу</button>
    <h1>Обране</h1>
    <request-state :loading="$store.getters.favoritesBusy && !products.length" :error="$store.getters.favoritesError" loading-text="Завантажуємо обране…" @retry="$store.dispatch('loadFavorites')" />
    <div v-if="!$store.getters.favoritesBusy && !$store.getters.favoritesError && !products.length" class="empty" role="status">
      <p>В обраному поки порожньо</p><p>Натисніть сердечко біля товару, щоб зберегти його.</p>
    </div>
    <div class="favorites-grid">
      <article v-for="product in products" :key="product.id" class="favorite-product">
        <img :src="product.img" :alt="product.name" />
        <button type="button" class="product-open-button" @click="open(product)">{{ product.name }}</button>
        <product-price :price="product.price" :old-price="product.price_old" />
        <product-availability :product="product" />
        <favorite-button :product="product" />
        <product-cart-control v-if="product.available !== false" :product="product" />
      </article>
    </div>
  </section>
</template>
<script>
import RequestState from '../../../components/RequestState.vue';
import ProductPrice from '../../../components/ProductPrice.vue';
import ProductAvailability from '../../../components/ProductAvailability.vue';
import FavoriteButton from '../../../components/FavoriteButton.vue';
import ProductCartControl from '../../../components/ProductCartControl.vue';
export default {
  components: { RequestState, ProductPrice, ProductAvailability, FavoriteButton, ProductCartControl },
  computed: { products() { return this.$store.getters.favorites; } },
  mounted() { this.$store.dispatch('loadFavorites'); },
  methods: {
    open(product) {
      this.$store.commit('addPerPage', 'favorites');
      this.$store.commit('setIsOpenProductInfo', product);
      this.$store.dispatch('getOneProduct', product.id);
      this.$emit('setIsChangePage', 'productInfo');
    },
  },
};
</script>
<style scoped>
.favorites-page { padding: 16px; }
h1 { font: 600 24px/32px Inter, sans-serif; margin: 16px 0; }
.back { min-height: 44px; background: #fff; border: 0; color: #075a63; cursor: pointer; }
.empty { padding: 32px 0; font: 14px/24px Inter, sans-serif; }
.favorites-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; }
.favorite-product { border: 1px solid #eee; padding: 12px; border-radius: 8px; min-width: 0; }
.favorite-product img { width: 100%; height: 140px; object-fit: contain; }
.favorite-product .product-open-button { font: 500 14px/20px Inter, sans-serif; overflow-wrap: anywhere; }
@media (min-width: 768px) { .favorites-grid { grid-template-columns: repeat(4, minmax(0, 1fr)); } }
</style>
